import React from "react";
import ReactDOM from "react-dom";

import "./index.css";

import Alert from "./components/Alert";

//import MobilQualifier from "./MobilQualifier";
import JuniorGolfSeries from "./JuniorGolfSeries";
import Clasificatorio from "./Clasificatorio";
import Contact from "./Contact";
import Newsletter from "./Newsletter";

/* uncomment for testing locally
	
note: for 2024, we made the match play form the one for clasificatorio

window.appSettings = {
	id: "junior-golf-series", // junior-golf-series, clasificatorio, contact, newsletter
	lang: "es",
	closed: false,
};*/

const target = document.getElementById("root");
if (target) {
	if (window.appSettings) {
		const { id, lang = "en", closed } = window.appSettings;

		ReactDOM.render(
			<React.StrictMode>
				{id === "junior-golf-series" ? (
					<JuniorGolfSeries lang={lang} closed={closed} />
				) : id === "clasificatorio" ? (
					<Clasificatorio lang={lang} closed={closed} />
				) : id === "contact" ? (
					<Contact lang={lang} />
				) : id === "newsletter" ? (
					<Newsletter lang={lang} />
				) : (
					<Alert
						data={{
							type: "notice",
							text: "No form selected.",
						}}
					/>
				)}
			</React.StrictMode>,
			target,
		);
	} else {
		ReactDOM.render(
			<React.StrictMode>
				<Alert
					data={{
						type: "error",
						text: "An error has occurred.",
					}}
				/>
			</React.StrictMode>,
			target,
		);
	}
}
